// Types
import { VesselDetail } from '@schemas/services';
import { DateRangeType } from '@globalTypes/index';
// Utils
import { RatingList } from '@constants/index';
import { vesselDetailToVesselRatingSummary } from '@utils/index';

/**
 * Transforms the VesselDetail data to the bar chart data format.
 *
 * @function
 * @param {VesselDetail[]} vesselDetail - The array of VesselDetail objects.
 * @returns {BarChartData} The transformed bar chart data.
 */
export const summaryToChartData = (vesselDetail: VesselDetail[]) => {
  if (!vesselDetail) {
    return { ytd: {}, eoy: {} };
  }

  const barChartData = RatingList.reduce(
    (acc, rating) => ({
      ...acc,
      ytd: {
        ...acc.ytd,
        [rating]: vesselDetailToVesselRatingSummary(vesselDetail, rating, DateRangeType.yearToDate),
      },
      eoy: {
        ...acc.eoy,
        [rating]: vesselDetailToVesselRatingSummary(vesselDetail, rating, DateRangeType.endOfYear),
      },
    }),
    { ytd: {}, eoy: {} }
  );

  return barChartData;
};
